import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const KPI = ({ title, subtitle, titleClassName = '', subtitleClassName = '', onClick = undefined, isActive = false }) => {
  return (
    <div
      onClick={onClick}
      className={classNames(`kpi-block flex-child-block ${isActive ? 'selected' : ''}`)}
    >
      <div className={classNames('kpi-title', titleClassName)}>{title}</div>
      <div className={classNames('kpi-subtitle', subtitleClassName)}>{subtitle}</div>
    </div>
  );
};

KPI.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node.isRequired,
  titleClassName: PropTypes.string,
  subtitleClassName: PropTypes.string,
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
};

export default KPI;
